import MultiForm from '@admin/components/multiform'
import Container from '@admin/components/container'
import PaymentMethod from './payment_method'
import Operations from './operations'
import PropTypes from 'prop-types'
import Cancel from './cancel'
import React from 'react'
import Plan from './plan'

class ManageSubscription extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    plans: PropTypes.object,
    subscription: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    const { plans, subscription } = this.props
    return {
      title: 't(Manage Subscription)',
      action: '/api/admin/team/subscription/manage',
      method: 'PATCH',
      props: {
        plans,
        subscription
      },
      getSteps: this._getSteps.bind(this),
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps(formdata) {
    const { operation } = formdata
    return [
      { label: 't(Operation)', component: Operations },
      {
        label: 't(Details)',
        ...operation === 'cancel' ? {
          component: Cancel
        } : operation === 'payment_method' ? {
          component: PaymentMethod
        } : operation === 'plan' ? {
          component: Plan
        } : {}
      }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(workflow) {
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  plans: '/api/admin/team/subscription/plans'
})

export default Container(mapResources)(ManageSubscription)
